export const colors = {
  accent: {
    default: '#0049FF',
    hover: '#426cf6',
    pressed: '#1539c4',
    disabled: '#87a3f8',
    transparent: 'rgba(0, 73, 255, 0.08)',
    50: '#E5EDFF',
    100: '#B8CCFF',
    200: '#8AABFF',
    300: '#5C8BFF',
    400: '#2E6AFF',
    500: '#0049FF',
    600: '#003ACC',
    700: '#002C99',
    800: '#001D66',
    900: '#000F33',
  },
  white: '#FFFFFF',
  black: '#000000',
  accentAlpha: {
    20: 'rgba(0, 73, 255, 0.02)',
    40: 'rgba(0, 73, 255, 0.04)',
    50: 'rgba(0, 73, 255, 0.05)',
    80: 'rgba(0, 73, 255, 0.08)',
    100: 'rgba(0, 73, 255, 0.1)',
    200: 'rgba(0, 73, 255, 0.2)',
    300: 'rgba(0, 73, 255, 0.3)',
    400: 'rgba(0, 73, 255, 0.4)',
    500: 'rgba(0, 73, 255, 0.5)',
    600: 'rgba(0, 73, 255, 0.6)',
    700: 'rgba(0, 73, 255, 0.7)',
    800: 'rgba(0, 73, 255, 0.8)',
    900: 'rgba(0, 73, 255, 0.9)',
  },
  whiteAlpha: {
    20: 'rgba(255, 255, 255, 0.02)',
    40: 'rgba(255, 255, 255, 0.04)',
    50: 'rgba(255, 255, 255, 0.05)',
    80: 'rgba(255, 255, 255, 0.08)',
    100: 'rgba(255, 255, 255, 0.1)',
    200: 'rgba(255, 255, 255, 0.2)',
    300: 'rgba(255, 255, 255, 0.3)',
    400: 'rgba(255, 255, 255, 0.4)',
    500: 'rgba(255, 255, 255, 0.5)',
    600: 'rgba(255, 255, 255, 0.6)',
    700: 'rgba(255, 255, 255, 0.7)',
    800: 'rgba(255, 255, 255, 0.8)',
    900: 'rgba(255, 255, 255, 0.9)',
  },
  blackAlpha: {
    20: 'rgba(0, 0, 0, 0.02)',
    40: 'rgba(0, 0, 0, 0.04)',
    50: 'rgba(0, 0, 0, 0.05)',
    80: 'rgba(0, 0, 0, 0.08)',
    100: 'rgba(0, 0, 0, 0.1)',
    200: 'rgba(0, 0, 0, 0.2)',
    300: 'rgba(0, 0, 0, 0.3)',
    400: 'rgba(0, 0, 0, 0.4)',
    500: 'rgba(0, 0, 0, 0.5)',
    600: 'rgba(0, 0, 0, 0.6)',
    700: 'rgba(0, 0, 0, 0.7)',
    800: 'rgba(0, 0, 0, 0.8)',
    900: 'rgba(0, 0, 0, 0.9)',
  },
  text: {
    primary: 'rgba(0, 0, 0, 1)',
    secondary: 'rgba(0, 0, 0, 0.8)',
    tertiary: 'rgba(0, 0, 0, 0.6)',
    quaternary: 'rgba(0, 0, 0, 0.4)',
    white: 'white',
  },
  background: {
    primary: 'white',
    secondary: 'rgba(0, 0, 0, 0.02)',
  },
  stroke: {
    grey: 'rgba(0, 0, 0, 0.1)',
    'grey-light': 'rgba(0, 0, 0, 0.05)',
    accent: '#0049FF',
    focused: '#87a3f8',
    error: '#F83A5C',
  },
  error: {
    default: '#F83A5C',
    hover: '#e76b7f',
    toast: '#F83A5C',
    pressed: '#b63c4d',
    disabled: 'rgba(228, 76, 96, 0.5)',
    transparent: 'rgba(228, 76, 96, 0.08)',
  },
  warning: {
    default: '#f4b444',
    toast: '#FFB11A',
    hover: '#f5c35f',
    pressed: '#c39136',
    disabled: 'rgba(244, 180, 68, 0.5)',
    transparent: 'rgba(244, 180, 68, 0.08)',
  },
  success: {
    default: '#5abe63',
    toast: '#19C157',
    hover: '#6fca81',
    pressed: '#479850',
    disabled: 'rgba(90, 190, 99, 0.5)',
    transparent: 'rgba(90, 190, 99, 0.08)',
  },
  tag: {
    1: { default: '#b8255f', transparent: 'rgba(184, 37, 95, 0.2)' },
    2: { default: '#db4035', transparent: 'rgba(219, 64, 53, 0.2)' },
    3: { default: '#ff9933', transparent: 'rgba(255, 153, 51, 0.2)' },
    4: { default: '#fad000', transparent: 'rgba(250, 208, 0, 0.2)' },
    5: { default: '#afb83b', transparent: 'rgba(175, 184, 59, 0.2)' },
    6: { default: '#7ecc49', transparent: 'rgba(126, 204, 73, 0.2)' },
    7: { default: '#299438', transparent: 'rgba(41, 148, 56, 0.2)' },
    8: { default: '#6accbc', transparent: 'rgba(106, 204, 188, 0.2)' },
    9: { default: '#158fad', transparent: 'rgba(21, 143, 173, 0.2)' },
    10: { default: '#14aaf5', transparent: 'rgba(20, 170, 245, 0.2)' },
    11: { default: '#96c3eb', transparent: 'rgba(150, 195, 235, 0.2)' },
    12: { default: '#4073ff', transparent: 'rgba(64, 115, 255, 0.2)' },
    13: { default: '#884dff', transparent: 'rgba(136, 77, 255, 0.2)' },
    14: { default: '#af38eb', transparent: 'rgba(175, 56, 235, 0.2)' },
    15: { default: '#eb96eb', transparent: 'rgba(235, 150, 235, 0.2)' },
    16: { default: '#e05194', transparent: 'rgba(224, 81, 148, 0.2)' },
    17: { default: '#ff8d85', transparent: 'rgba(255, 141, 133, 0.2)' },
    18: { default: '#808080', transparent: 'rgba(128, 128, 128, 0.2)' },
    19: { default: '#b8b8b8', transparent: 'rgba(184, 184, 184, 0.2)' },
    20: { default: '#ccac93', transparent: 'rgba(204, 172, 147, 0.2)' },
  },
};
